import { createAjaxRefresh } from '../blesksport/ajaxRefresh';
import { setTodayResultsCollapsing } from '../blesksport/sportmod-today-results';
import { navigation } from '../blesksport/navigation/navigation';
import { dynamicNavigation } from '../blesksport/navigation/dynamicNavigation';
import { swiper } from '../blesksport/swiper';
import { breakingNews } from '../blesksport/navigation/breakingNews/breakingNews';
import HalfPageManager from '@box/ads/HalfPageManager/HalfPageManager';
import { createArticleListed } from '../blesksport/articleListed';

declare global {
  interface Window {
    createAjaxRefresh: typeof createAjaxRefresh;
    setTodayResultsCollapsing: typeof setTodayResultsCollapsing;
    navigation: typeof navigation;
    dynamicNavigationInit: typeof dynamicNavigation;
    swiper: typeof swiper;
    breakingNews: typeof breakingNews;
    HalfPageManager: typeof HalfPageManager;
    createArticleListed: typeof createArticleListed;
  }
}

// Register global functions
window.createAjaxRefresh = createAjaxRefresh;
window.setTodayResultsCollapsing = setTodayResultsCollapsing;
window.navigation = navigation;
window.dynamicNavigationInit = dynamicNavigation;
window.swiper = swiper;
window.breakingNews = breakingNews;
window.HalfPageManager = HalfPageManager;
window.createArticleListed = createArticleListed;

// Initialize features
document.addEventListener('DOMContentLoaded', () => {
  const navigationElement: HTMLElement | null = document.querySelector('[data-navigation]');
  if (navigationElement) {
    navigation(navigationElement);
  }

  const swiperInit = () => {
    const swiperSelectors: NodeListOf<HTMLElement> = document.querySelectorAll('[data-swiper]');
    if (swiperSelectors.length > 0) {
      for (const swiperSelector of swiperSelectors) {
        if (swiperSelector instanceof HTMLDivElement) swiper(swiperSelector);
      }
    }
  };

  const dynamicNavigationTemplate: HTMLTemplateElement | null = document.querySelector(
    '[data-dynamic-navigation-template]'
  );
  if (dynamicNavigationTemplate) {
    dynamicNavigation(dynamicNavigationTemplate);
    swiperInit();
  }

  const breakingNewsTemplate: HTMLTemplateElement | null = document.querySelector(
    '[data-breaking-news-template]'
  );
  if (breakingNewsTemplate) {
    breakingNews(breakingNewsTemplate);
  }
});

export {
  createAjaxRefresh,
  setTodayResultsCollapsing,
  navigation,
  dynamicNavigation,
  swiper,
  breakingNews,
  HalfPageManager,
};
